<template>
	<div class="bind-copy">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">
			<el-form-item label="URL：" prop="url">
				<el-input placeholder="请输入URL" v-model="form.url" clearable disabled></el-input>
				<el-button type="text" @click="onCopy('url')">复制</el-button>
			</el-form-item>
			<el-form-item label="AppKey：" prop="appKey">
				<el-input placeholder="请输入AppKey" v-model="form.appKey" clearable disabled></el-input>
				<el-button type="text" @click="onCopy('AppKey')">复制</el-button>
			</el-form-item>
		</el-form>
		<p class="tips">将生成的URL和AppKey填入微博帐号“管理中心”-“消息管理”-“开发者中心”-“服务器配置”，生成access_token</p>
		<div class="footer">
			<el-button size="mini" @click="getData">重新获取</el-button>
			<el-button type="primary" size="mini" @click="onNext">下一步
			</el-button>
		</div>
	</div>
</template>

<script>
	import {copyTextToClipboard} from '@/utils/functions.js'
	export default {
		props:{
			source:{
				default:''
			},
			basicSource:{
				default:''
			}
		},
		watch:{
			source:{
				handler(value){
					if(value || this.basicSource){
						this.getAppkey();
						this.getCallbackUrl();
					}
				},
				deep:true,
				immediate:true
			}
		},
		data(){
			return {
				form:{
					url:'',
					appKey:'',
				},
				rules:{
					url:[{ required: true, message: '请输入URL', trigger: 'blur' }],
					appKey:[{ required: true, message: '请输入AppKey', trigger: 'blur' }],
				},
			}
		},
		methods:{
			onCopy(key){
				copyTextToClipboard(this.form[key],()=>{
					this.$notify.success("复制成功")
				})
			},
			onNext(){
				this.$emit('onNext',this.form)
			},
			async getData(){
				await this.getAppkey();
				await this.getCallbackUrl();
			},
			getAppkey(){
				this.$api.getWeiboAppkeyForSystem().then(res => {
					if(res.errcode != 0) return;
					this.form.appKey = res.data;
				})
			},
			getCallbackUrl(){
				this.$api.getWeiboUrlForSystem().then(res => {
					if(res.errcode != 0) return;
					let url = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_BASE_API : window.location.origin;
					let results = res.data.replace('{weiboid}',this.source?.weiboId || this.basicSource?.weiboid);
					this.form.url = url + results;
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bind-copy {
		::v-deep {
			.el-form-item__content {
				display: flex;
			}
			.el-button--text {
				display: inline-block;
				margin-left: 20px;
			}
		}
		.tips {
			font-size: 12px;
			color: #F29522;
			padding-left: 120px;
			margin: 15px 0;
		}
		.footer {
			float: right;
		}
	}
</style>
